<div class="asset-details-root">
    <div class="asset-details-header">
        <div class="row">
            <div class="asset-header-back-button col-auto" (click)="backClicked()">
                <button class="action-button">
                    <svg width="15" height="12" viewBox="0 0 15 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M5.71 1.28906L1 5.99906L5.71 10.7091M1.5652 5.99906H13.4344" stroke="#17171A"
                            stroke-opacity="0.9" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                    </svg>
                </button>
            </div>
            <div class="asset-header-info" [ngClass]="headerExpanded ? 'col-3' : 'col-4'">
                <div class="row">
                    <div class="col-12 header-title" *ngIf="!headerExpanded">
                        <b>{{title}} {{ "COMMON.SLRN" | translate }}</b>
                    </div>
                    <div *ngIf="!headerExpanded" class="light-gray-text col-auto">
                        {{ selectedSubstation.slrn }}
                    </div>
                    <!-- <div class="pill header-pill col-auto"
                                [ngClass]="{'light-gray-pill' : selectedMvPole.status == 'Pending',
                                'light-orange-pill' : selectedMvPole.status == 'Assigned' || selectedMvPole.status == 'Retagged', 
                                'green-success-pill': selectedMvPole.status == 'Complete', 'red-failure-pill': selectedMvPole.status == 'Rejected'}">
                                {{ selectedMvPole.status }} 
                                </div>  -->
                </div>
            </div>
            <div class="header-actions col">
                <button *ngIf="permissionsService.isNetworkStructureGisReviewAllowed" class="btn asset-header-action-button" data-bs-toggle="modal" data-bs-target="#gisReview" [disabled]="disableGisReviewButton()">
                    {{ "ROLE_MANAGEMENT.GIS_REVIEW" | translate }}
                </button>
                <button class="btn asset-header-action-button" data-bs-toggle="modal"
                    (click)="assetAssignType = AssetAssignType.Retagged" data-bs-target="#assignToFieldAgent">
                    {{ "COMMON.RETAG" | translate }}
                </button>
                <div class="recall-container position-relative d-inline-block" *ngIf="
                    permissionsService.isNetworkStructureRecallValidatedAllowed ||
                    permissionsService.isNetworkStructureRecallAssignedAllowed
                ">
                    <button *ngIf="recallValidatedTask || recallAssignedTask" class="btn asset-header-action-button"
                        (click)="showRecallMenu = !showRecallMenu">
                        {{ "COMMON.RECALL" | translate }}
                    </button>
                    <div *ngIf="showRecallMenu" class="recall-options shadow-sm" @slideToggle>
                        <div *ngIf="recallAssignedTask && permissionsService.isNetworkStructureRecallAssignedAllowed" class="recall-type" [ngClass]="
                        !recallAssignedAllowed
                        ? 'recall-type-disabled'
                        : 'recall-type-enabled'
                    " (click)="recallAssignedAllowed ? recall('Assigned') : null">
                            <span>{{ "COMMON.ASSIGNED_TASK" | translate }}</span>
                        </div>
                        <div *ngIf="recallValidatedTask && permissionsService.isNetworkStructureRecallValidatedAllowed" class="recall-type" [ngClass]="
                        !recallValidatedAllowed
                        ? 'recall-type-disabled'
                        : 'recall-type-enabled'
                    " (click)="recallValidatedAllowed ? recall('Validated') : null">
                            <span>{{ "COMMON.VALIDATED_TASK" | translate }}</span>
                        </div>
                    </div>
                </div>
                <button *ngIf="permissionsService.isNetworkStructureApproveRejectAllowed" class="btn asset-header-action-button" data-bs-toggle="modal" data-bs-target="#updateStatus"
                    [disabled]="selectedSubstation.dataQualityId">
                    {{ "COMMON.UPDATE_STATUS" | translate }}
                </button>
                <button *ngIf="permissionsService.isNetworkStructureAuditReviewAllowed" class="btn asset-header-action-button" data-bs-toggle="modal" data-bs-target="#auditReview"
                    [disabled]="selectedSubstation.auditedStatus === 'Audited'">
                    {{ "COMMON.FIELD_AUDIT" | translate }}
                </button>
                <button *ngIf="permissionsService.isNetworkStructureReviewAllowed" class="btn asset-header-action-button" data-bs-toggle="modal" data-bs-target="#review" [disabled]="disableReviewButton()">
                    {{'COMMON.REVIEW_BUTTON' | translate}}
                </button>
                <button *ngIf="permissionsService.isNetworkStructureAssignAllowed" class="btn asset-header-action-button" data-bs-toggle="modal"
                    (click)="assetAssignType = AssetAssignType.Assigned" data-bs-target="#assignToFieldAgent">
                    {{ "COMMON.ASSIGN_AGENT" | translate }}
                </button>
                <button *ngIf="!editEnabled && permissionsService.isNetworkStructureCreateEditAllowed" class="btn asset-header-action-button" (click)="editEnabled = true">
                    {{ "COMMON.EDIT" | translate }}
                </button>
                <button *ngIf="editEnabled && permissionsService.isNetworkStructureCreateEditAllowed" class="btn asset-header-action-button asset-header-save-button"
                    (click)="saveAttributeValues()">
                    {{ "COMMON.SAVE" | translate }}
                </button>
            </div>
        </div>
    </div>
    <div class="asset-details-content">
        <div class="row">
            <div class="col-xl-4 col-md-6 d-flex flex-column gap-3">
                <div class="asset-card col-12"
                    [ngClass]="networkCardExpanded ? 'asset-card-expanded' : 'asset-card-collapsed'">
                    <div class="asset-card-header row">
                        <h2 class="card-title asset-card-title col-10">
                            {{ "EDIT_INJECTION_SUBSTATION.NETWORK_INFO.TITLE" | translate }}
                        </h2>
                        <div class="collapse-arrow col-2">
                            <button class="action-button" (click)="networkCardExpanded = true"
                                *ngIf="!networkCardExpanded">
                                <svg *ngIf="!networkCardExpanded" width="10" height="6" viewBox="0 0 10 6" fill="none"
                                    xmlns="http://www.w3.org/2000/svg">
                                    <path d="M1 1L5 5L9 1" stroke="#17171A" stroke-width="1.5" stroke-linecap="round"
                                        stroke-linejoin="round" />
                                </svg>
                            </button>
                            <button class="action-button" (click)="networkCardExpanded = false"
                                *ngIf="networkCardExpanded">
                                <svg width="10" height="6" viewBox="0 0 10 6" fill="none"
                                    xmlns="http://www.w3.org/2000/svg">
                                    <path d="M9 5L5 1L1 5" stroke="#17171A" stroke-width="1.5" stroke-linecap="round"
                                        stroke-linejoin="round" />
                                </svg>
                            </button>
                        </div>
                    </div>
                    <div *ngIf="networkCardExpanded" class="asset-card-content" @slideToggle>
                        <div class="asset-card-info row">
                            <div class="col-5 asset-card-content-title"> Substation Name </div>
                            <div class="col-7 asset-card-content-value">
                                {{ selectedSubstation.name | hasValue }}
                            </div>
                        </div>
                        <div class="asset-card-info row">
                            <div class="col-7 asset-card-content-title"> Substation Number </div>
                            <div class="col-5 asset-card-content-value">
                                {{ selectedSubstation.number | hasValue }}
                            </div>
                        </div>
                        <div class="asset-card-info row" *ngIf="selectedSubstation.incomingAcLines.length">
                            <div class="col-12">
                                <div class="parent-substation-header">
                                    <div class="parent-substation-type asset-card-content-title">
                                        Parent Substation
                                    </div>

                                    <div class="parent-substation-type-count">
                                        {{ selectedSubstation.incomingAcLines.length }}
                                    </div>

                                    <div class="parent-substation-list-scrolling">
                                        <button (click)="prevIncomingAcLine()"
                                            [disabled]="currentIncomingAcLineIndex === 0" class="action-button">
                                            <svg width="13" height="13" viewBox="0 0 13 13" fill="none"
                                                xmlns="http://www.w3.org/2000/svg">
                                                <path
                                                    d="M2.83366 7.15667H12.1462C12.3823 7.15667 12.5802 7.07681 12.7399 6.91708C12.8996 6.75736 12.9795 6.55944 12.9795 6.32333C12.9795 6.08722 12.8996 5.88931 12.7399 5.72958C12.5802 5.56986 12.3823 5.49 12.1462 5.49H2.83366L6.91699 1.40667C7.08366 1.24 7.16352 1.04556 7.15658 0.823333C7.14963 0.601111 7.06283 0.406667 6.89616 0.24C6.72949 0.0872222 6.53505 0.00736111 6.31283 0.000416667C6.0906 -0.00652778 5.89616 0.0733333 5.72949 0.24L0.229492 5.74C0.146159 5.82333 0.0871315 5.91361 0.0524092 6.01083C0.0176868 6.10806 0.000326157 6.21222 0.000326157 6.32333C0.000326157 6.43444 0.0176868 6.53861 0.0524092 6.63583C0.0871315 6.73306 0.146159 6.82333 0.229492 6.90667L5.72949 12.4067C5.88227 12.5594 6.07324 12.6358 6.30241 12.6358C6.53158 12.6358 6.72949 12.5594 6.89616 12.4067C7.06283 12.24 7.14616 12.0421 7.14616 11.8129C7.14616 11.5838 7.06283 11.3858 6.89616 11.2192L2.83366 7.15667Z"
                                                    fill="#F36943" />
                                            </svg>
                                        </button>
                                        <div class="parent-substation-count-text">
                                            {{ currentIncomingAcLineIndex + 1 }} of {{
                                            selectedSubstation.incomingAcLines.length }}
                                        </div>
                                        <button (click)="nextIncomingAcLine()"
                                            [disabled]="currentIncomingAcLineIndex === selectedSubstation.incomingAcLines.length - 1"
                                            class="action-button">
                                            <svg width="13" height="13" viewBox="0 0 13 13" fill="none"
                                                xmlns="http://www.w3.org/2000/svg">
                                                <path
                                                    d="M10.1458 7.15667H0.833333C0.597222 7.15667 0.399306 7.07681 0.239583 6.91708C0.0798611 6.75736 0 6.55944 0 6.32333C0 6.08722 0.0798611 5.88931 0.239583 5.72958C0.399306 5.56986 0.597222 5.49 0.833333 5.49H10.1458L6.0625 1.40667C5.89583 1.24 5.81597 1.04556 5.82292 0.823333C5.82986 0.601111 5.91667 0.406667 6.08333 0.24C6.25 0.0872222 6.44444 0.00736111 6.66667 0.000416667C6.88889 -0.00652778 7.08333 0.0733333 7.25 0.24L12.75 5.74C12.8333 5.82333 12.8924 5.91361 12.9271 6.01083C12.9618 6.10806 12.9792 6.21222 12.9792 6.32333C12.9792 6.43444 12.9618 6.53861 12.9271 6.63583C12.8924 6.73306 12.8333 6.82333 12.75 6.90667L7.25 12.4067C7.09722 12.5594 6.90625 12.6358 6.67708 12.6358C6.44792 12.6358 6.25 12.5594 6.08333 12.4067C5.91667 12.24 5.83333 12.0421 5.83333 11.8129C5.83333 11.5838 5.91667 11.3858 6.08333 11.2192L10.1458 7.15667Z"
                                                    fill="#F36943" />
                                            </svg>
                                        </button>
                                    </div>
                                </div>

                                <div class="asset-card-content parent-substation-details-content"
                                    *ngIf="selectedSubstation.incomingAcLines[currentIncomingAcLineIndex] as currentIncomingAcLine">
                                    <div class="asset-card-info row">
                                        <div class="col-6 asset-card-content-title"> Parent Substation Name </div>
                                        <div class="col-6 asset-card-content-value">
                                            {{ currentIncomingAcLine.parentSubstationName | hasValue }}
                                        </div>
                                    </div>
                                    <div class="asset-card-info row">
                                        <div class="col-5 asset-card-content-title"> Connected AC Line </div>
                                        <div class="col-7 asset-card-content-value">
                                            {{ currentIncomingAcLine.parentACLineName | hasValue }}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="asset-card-info row" *ngIf="selectedSubstation.pendingIncomingAcLines.length">
                            <div class="col-12">
                                <div class="parent-substation-header">
                                    <div class="parent-substation-type asset-card-content-title">
                                        {{ "COMMON.PROPOSED_PARENT_SUBSTATION" | translate }}
                                    </div>
                                    <div class="parent-substation-type-count">
                                        {{ selectedSubstation.pendingIncomingAcLines.length }}
                                    </div>

                                    <div class="parent-substation-list-scrolling">
                                        <button (click)="prevPendingIncomingAcLine()"
                                            [disabled]="currentPendingIncomingAcLineIndex === 0" class="action-button">
                                            <svg width="13" height="13" viewBox="0 0 13 13" fill="none"
                                                xmlns="http://www.w3.org/2000/svg">
                                                <path
                                                    d="M2.83366 7.15667H12.1462C12.3823 7.15667 12.5802 7.07681 12.7399 6.91708C12.8996 6.75736 12.9795 6.55944 12.9795 6.32333C12.9795 6.08722 12.8996 5.88931 12.7399 5.72958C12.5802 5.56986 12.3823 5.49 12.1462 5.49H2.83366L6.91699 1.40667C7.08366 1.24 7.16352 1.04556 7.15658 0.823333C7.14963 0.601111 7.06283 0.406667 6.89616 0.24C6.72949 0.0872222 6.53505 0.00736111 6.31283 0.000416667C6.0906 -0.00652778 5.89616 0.0733333 5.72949 0.24L0.229492 5.74C0.146159 5.82333 0.0871315 5.91361 0.0524092 6.01083C0.0176868 6.10806 0.000326157 6.21222 0.000326157 6.32333C0.000326157 6.43444 0.0176868 6.53861 0.0524092 6.63583C0.0871315 6.73306 0.146159 6.82333 0.229492 6.90667L5.72949 12.4067C5.88227 12.5594 6.07324 12.6358 6.30241 12.6358C6.53158 12.6358 6.72949 12.5594 6.89616 12.4067C7.06283 12.24 7.14616 12.0421 7.14616 11.8129C7.14616 11.5838 7.06283 11.3858 6.89616 11.2192L2.83366 7.15667Z"
                                                    fill="#F36943" />
                                            </svg>
                                        </button>
                                        <div class="parent-substation-count-text">
                                            {{ currentPendingIncomingAcLineIndex + 1 }} of {{
                                            selectedSubstation.pendingIncomingAcLines.length }}
                                        </div>
                                        <button (click)="nextPendingIncomingAcLine()"
                                            [disabled]="currentPendingIncomingAcLineIndex === selectedSubstation.pendingIncomingAcLines.length - 1"
                                            class="action-button">
                                            <svg width="13" height="13" viewBox="0 0 13 13" fill="none"
                                                xmlns="http://www.w3.org/2000/svg">
                                                <path
                                                    d="M10.1458 7.15667H0.833333C0.597222 7.15667 0.399306 7.07681 0.239583 6.91708C0.0798611 6.75736 0 6.55944 0 6.32333C0 6.08722 0.0798611 5.88931 0.239583 5.72958C0.399306 5.56986 0.597222 5.49 0.833333 5.49H10.1458L6.0625 1.40667C5.89583 1.24 5.81597 1.04556 5.82292 0.823333C5.82986 0.601111 5.91667 0.406667 6.08333 0.24C6.25 0.0872222 6.44444 0.00736111 6.66667 0.000416667C6.88889 -0.00652778 7.08333 0.0733333 7.25 0.24L12.75 5.74C12.8333 5.82333 12.8924 5.91361 12.9271 6.01083C12.9618 6.10806 12.9792 6.21222 12.9792 6.32333C12.9792 6.43444 12.9618 6.53861 12.9271 6.63583C12.8924 6.73306 12.8333 6.82333 12.75 6.90667L7.25 12.4067C7.09722 12.5594 6.90625 12.6358 6.67708 12.6358C6.44792 12.6358 6.25 12.5594 6.08333 12.4067C5.91667 12.24 5.83333 12.0421 5.83333 11.8129C5.83333 11.5838 5.91667 11.3858 6.08333 11.2192L10.1458 7.15667Z"
                                                    fill="#F36943" />
                                            </svg>
                                        </button>
                                    </div>
                                </div>

                                <div class="asset-card-content parent-substation-details-content"
                                    [class.proposed-addition]="isProposedAddition(pendingAcLine)"
                                    *ngIf="selectedSubstation.pendingIncomingAcLines[currentPendingIncomingAcLineIndex] as pendingAcLine">
                                    <div class="asset-card-info row">
                                        <div class="col-6 asset-card-content-title"> Parent Substation Name </div>
                                        <div class="col-6 asset-card-content-value">
                                            {{ pendingAcLine.parentSubstationName | hasValue }}
                                        </div>
                                    </div>
                                    <div class="asset-card-info row">
                                        <div class="col-5 asset-card-content-title"> Connected AC Line </div>
                                        <div class="col-7 asset-card-content-value">
                                            {{ pendingAcLine.parentACLineName | hasValue }}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="asset-card-info row">
                            <div class="col-6 asset-card-content-title"> Sub Geographical Region </div>
                            <div class="col-6 asset-card-content-value">
                                {{ selectedSubstation.subGeographicalRegion | hasValue }}
                            </div>
                        </div>
                        <div class="asset-card-info row">
                            <div class="col-7 asset-card-content-title"> Geographical Region </div>
                            <div class="col-5 asset-card-content-value">
                                {{ selectedSubstation.geographicalRegion | hasValue }}
                            </div>
                        </div>
                        <div class="asset-card-info row">
                            <div class="col-5 asset-card-content-title">{{'MV_POLES.GEOLOCATION' | translate}}</div>
                            <div class="col-6 asset-card-content-value">{{ selectedSubstation.latitude }}, {{
                                selectedSubstation.longitude }}</div>
                            <div class="geo-icon col-auto" (click)="isMapVisible = !isMapVisible">
                                <svg width="16" height="16" viewBox="0 0 16 16" data-bs-toggle="modal"
                                    data-bs-target="#showMap" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path
                                        d="M8 0C8.30376 0 8.55479 0.225723 8.59452 0.518583L8.6 0.6L8.59925 2.03017C11.4343 2.31006 13.6899 4.56575 13.9706 7.40203L14 7.4H15.4C15.7314 7.4 16 7.66863 16 8C16 8.30376 15.7743 8.55479 15.4814 8.59452L15.4 8.6L13.9693 8.59923C13.6899 11.4343 11.4343 13.6899 8.59797 13.9706L8.6 14V15.4C8.6 15.7314 8.33137 16 8 16C7.69624 16 7.44521 15.7743 7.40548 15.4814L7.4 15.4L7.40077 13.9693C4.56575 13.6899 2.31006 11.4343 2.02942 8.59797L2 8.6H0.6C0.268629 8.6 0 8.33137 0 8C0 7.69624 0.225723 7.44521 0.518583 7.40548L0.6 7.4L2.03017 7.40075C2.31006 4.56575 4.56575 2.31006 7.40203 2.02942L7.4 2V0.6C7.4 0.268629 7.66863 0 8 0ZM8 3.2C5.34903 3.2 3.2 5.34903 3.2 8C3.2 10.651 5.34903 12.8 8 12.8C10.651 12.8 12.8 10.651 12.8 8C12.8 5.34903 10.651 3.2 8 3.2ZM8 4.8C9.76731 4.8 11.2 6.23269 11.2 8C11.2 9.76731 9.76731 11.2 8 11.2C6.23269 11.2 4.8 9.76731 4.8 8C4.8 6.23269 6.23269 4.8 8 4.8Z"
                                        fill="var(--primary-color)" />
                                </svg>
                            </div>
                        </div>
                            <div class="asset-card-info row" *ngIf="voltageClass == 'LV'" >
                            <div class="col-7 asset-card-content-title"> Number of Upriser </div>
                            <div class="col-5 asset-card-content-value">
                                {{ selectedSubstation.numberOfUprisers | hasValue }}
                            </div>
                        </div>
                    </div>
                </div>
                <div class="asset-card col-12"
                    [ngClass]="dsMeterCardExpanded ? 'asset-card-expanded' : 'asset-card-collapsed'">
                    <div class="asset-card-header row">
                        <h2 class="card-title asset-card-title col-10">
                            {{ "TRANSFORMERS.EDIT.METER_STATUS" | translate }}
                        </h2>
                        <div class="collapse-arrow col-2">
                            <button class="action-button" (click)="dsMeterCardExpanded = true"
                                *ngIf="!dsMeterCardExpanded">
                                <svg *ngIf="!dsMeterCardExpanded" width="10" height="6" viewBox="0 0 10 6" fill="none"
                                    xmlns="http://www.w3.org/2000/svg">
                                    <path d="M1 1L5 5L9 1" stroke="#17171A" stroke-width="1.5" stroke-linecap="round"
                                        stroke-linejoin="round" />
                                </svg>
                            </button>
                            <button class="action-button" (click)="dsMeterCardExpanded = false"
                                *ngIf="dsMeterCardExpanded">
                                <svg width="10" height="6" viewBox="0 0 10 6" fill="none"
                                    xmlns="http://www.w3.org/2000/svg">
                                    <path d="M9 5L5 1L1 5" stroke="#17171A" stroke-width="1.5" stroke-linecap="round"
                                        stroke-linejoin="round" />
                                </svg>
                            </button>
                        </div>
                    </div>
                    <div *ngIf="dsMeterCardExpanded" class="asset-card-content" @slideToggle>
                        <div class="asset-card-info row" *ngIf="isMeterInstalledEditable; else meterInstalledView">
                            <lib-static-dropdown-edit-row [label]="'TRANSFORMERS.EDIT.METER_INSTALLED' | translate"
                                [options]="yesNoOptions" [originalValue]="staticOriginals.MeterInstalled"
                                [(value)]="editedStaticValues.MeterInstalled" [externalError]="addMeterError">
                            </lib-static-dropdown-edit-row>
                        </div>
                        <ng-template #meterInstalledView>
                            <div class="asset-card-info row">
                                <div class="col-7 asset-card-content-title">
                                    {{ "TRANSFORMERS.EDIT.METER_INSTALLED" | translate }}
                                </div>
                                <div class="col-5 asset-card-content-value">
                                    {{ (selectedSubstation.meterId
                                        ? ("EDIT_INJECTION_SUBSTATION.DS_METER.YES" | translate)
                                        : ("EDIT_INJECTION_SUBSTATION.DS_METER.NO" | translate)) }}
                                </div>
                            </div>
                        </ng-template>
                        <ng-container *ngIf="isMeterInstalled && !addMeterError">
                            <ng-container *ngIf="isStaticEditable('ProposedLocation'); else repositioningView">
                                <div class="asset-card-info row">
                                    <lib-static-dropdown-edit-row [label]="'TRANSFORMERS.EDIT.METER_REPOSITIONING' | translate"
                                        [options]="yesNoOptions" [originalValue]="isAddingMeter ? null : !!staticOriginals.ProposedLocation"
                                        [isRequired]="isAddingMeter"
                                        [value]="needsRepositioning" (valueChange)="onRepositioningChange($event)">
                                    </lib-static-dropdown-edit-row>
                                </div>
                                <div class="asset-card-info row" *ngIf="showProposedLocationEdit">
                                    <lib-static-dropdown-edit-row [label]="'TRANSFORMERS.EDIT.PROPOSED_LOCATION' | translate"
                                        [options]="proposedLocationOptions" [isRequired]="true"
                                        [originalValue]="staticOriginals.ProposedLocation" [(value)]="editedStaticValues.ProposedLocation">
                                    </lib-static-dropdown-edit-row>
                                </div>
                            </ng-container>
                            <ng-template #repositioningView>
                                <div class="asset-card-info row">
                                    <div class="col-7 asset-card-content-title">
                                        {{ "TRANSFORMERS.EDIT.METER_REPOSITIONING" | translate }}
                                    </div>
                                    <div class="col-5 asset-card-content-value">
                                        {{ (selectedSubstation.proposedLocation
                                            ? ("EDIT_INJECTION_SUBSTATION.DS_METER.YES" | translate)
                                            : ("EDIT_INJECTION_SUBSTATION.DS_METER.NO" | translate)) }}
                                    </div>
                                </div>
                                <div class="asset-card-info row" *ngIf="selectedSubstation.proposedLocation">
                                    <div class="col-7 asset-card-content-title">
                                        {{ "TRANSFORMERS.EDIT.PROPOSED_LOCATION" | translate }}
                                    </div>
                                    <div class="col-5 asset-card-content-value">
                                        {{ selectedSubstation.proposedLocation | hasValue }}
                                    </div>
                                </div>
                            </ng-template>
                            <div class="asset-card-info row">
                                <div class="col-7 asset-card-content-title">
                                    {{ "TRANSFORMERS.EDIT.METERING_CABLE_VISIBLE" | translate }}
                                </div>
                                <div class="col-5 asset-card-content-value">
                                    {{ (selectedSubstation.isCableVisible
                                        ? ("EDIT_INJECTION_SUBSTATION.DS_METER.YES" | translate)
                                        : ("EDIT_INJECTION_SUBSTATION.DS_METER.NO" | translate)) }}
                                </div>
                            </div>
                            <div class="asset-card-info row" *ngIf="isStaticEditable('IsCableLengthEnough'); else xlpeCableLengthView">
                                <lib-static-dropdown-edit-row [label]="'TRANSFORMERS.EDIT.XLPE_CABLE_LENGTH' | translate"
                                    [options]="yesNoOptions" [originalValue]="staticOriginals.IsCableLengthEnough"
                                    [isRequired]="isAddingMeter" [(value)]="editedStaticValues.IsCableLengthEnough">
                                </lib-static-dropdown-edit-row>
                            </div>
                            <ng-template #xlpeCableLengthView>
                                <div class="asset-card-info row">
                                    <div class="col-7 asset-card-content-title">
                                        {{ "TRANSFORMERS.EDIT.XLPE_CABLE_LENGTH" | translate }}
                                    </div>
                                    <div class="col-5 asset-card-content-value">
                                        {{ (selectedSubstation.isCableLengthEnough
                                            ? ("EDIT_INJECTION_SUBSTATION.DS_METER.YES" | translate)
                                            : ("EDIT_INJECTION_SUBSTATION.DS_METER.NO" | translate)) }}
                                    </div>
                                </div>
                            </ng-template>
                            <div class="asset-card-info row" *ngIf="isStaticEditable('ConditionOfMeter'); else meterConditionView">
                                <lib-static-dropdown-edit-row [label]="'TRANSFORMERS.EDIT.CONDITION' | translate"
                                    [options]="meterConditionOptions" [isRequired]="true"
                                    [originalValue]="staticOriginals.ConditionOfMeter" [(value)]="editedStaticValues.ConditionOfMeter">
                                </lib-static-dropdown-edit-row>
                            </div>
                            <ng-template #meterConditionView>
                                <div class="asset-card-info row">
                                    <div class="col-7 asset-card-content-title">
                                        {{ "TRANSFORMERS.EDIT.CONDITION" | translate }}
                                    </div>
                                    <div class="col-5 asset-card-content-value">
                                        {{ selectedSubstation.meterCondition | hasValue }}
                                    </div>
                                </div>
                            </ng-template>
                            <div class="asset-card-info row">
                                <div class="col-7 asset-card-content-title">
                                    {{ "COMMON.DT_METER_TYPE.SINGLE" | translate }}
                                </div>
                                <div class="col-5 asset-card-content-value">
                                    {{ selectedSubstation.meterType | hasValue }}
                                </div>
                            </div>
                            <div class="asset-card-info row" *ngIf="isStaticEditable('MeterCommunicationSystem'); else communicationStatusView">
                                <lib-static-dropdown-edit-row [label]="'TRANSFORMERS.EDIT.COMMUNICATION_STATUS' | translate"
                                    [options]="meterCommunicationStatusOptions" [isRequired]="true"
                                    [originalValue]="staticOriginals.MeterCommunicationSystem" [(value)]="editedStaticValues.MeterCommunicationSystem">
                                </lib-static-dropdown-edit-row>
                            </div>
                            <ng-template #communicationStatusView>
                                <div class="asset-card-info row">
                                    <div class="col-7 asset-card-content-title">
                                        {{ "TRANSFORMERS.EDIT.COMMUNICATION_STATUS" | translate }}
                                    </div>
                                    <div class="col-5 asset-card-content-value">
                                        {{ selectedSubstation.meterCommunicationStatus | hasValue }}
                                    </div>
                                </div>
                            </ng-template>
                            <div class="asset-card-info row" *ngIf="isStaticEditable('MeterBrand'); else meterBrandView">
                                <lib-static-dropdown-edit-row [label]="'TRANSFORMERS.EDIT.METER_BRAND' | translate"
                                    [options]="meterBrandOptions" [isRequired]="true"
                                    [originalValue]="staticOriginals.MeterBrand" [(value)]="editedStaticValues.MeterBrand">
                                </lib-static-dropdown-edit-row>
                            </div>
                            <ng-template #meterBrandView>
                                <div class="asset-card-info row">
                                    <div class="col-7 asset-card-content-title">
                                        {{ "TRANSFORMERS.EDIT.METER_BRAND" | translate }}
                                    </div>
                                    <div class="col-5 asset-card-content-value">
                                        {{ selectedSubstation.meterBrand | hasValue }}
                                    </div>
                                </div>
                            </ng-template>
                            <div class="asset-card-info row" *ngIf="isStaticEditable('MeterNumber'); else meterNumberView">
                                <lib-static-text-edit-row [label]="'TRANSFORMERS.EDIT.METER_NUM' | translate" [isRequired]="true"
                                    [originalValue]="staticOriginals.MeterNumber" [(value)]="editedStaticValues.MeterNumber">
                                </lib-static-text-edit-row>
                            </div>
                            <ng-template #meterNumberView>
                                <div class="asset-card-info row">
                                    <div class="col-7 asset-card-content-title">
                                        {{ "TRANSFORMERS.EDIT.METER_NUM" | translate }}
                                    </div>
                                    <div class="col-5 asset-card-content-value">
                                        {{ selectedSubstation.meterNumber | hasValue }}
                                    </div>
                                </div>
                            </ng-template>
                        </ng-container>
                    </div>
                </div>
                <div class="asset-card col-12"
                    [ngClass]="userActionsCardExpanded ? 'asset-card-expanded' : 'asset-card-collapsed'">
                    <div class="asset-card-header row">
                        <h2 class="card-title asset-card-title col-10">
                            {{ "MV_POLES.USER_ACTIVITY" | translate }}
                        </h2>
                        <div class="collapse-arrow col-2">
                            <button class="action-button" (click)="userActionsCardExpanded = true"
                                *ngIf="!userActionsCardExpanded">
                                <svg *ngIf="!userActionsCardExpanded" width="10" height="6" viewBox="0 0 10 6"
                                    fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M1 1L5 5L9 1" stroke="#17171A" stroke-width="1.5" stroke-linecap="round"
                                        stroke-linejoin="round" />
                                </svg>
                            </button>
                            <button class="action-button" (click)="userActionsCardExpanded = false"
                                *ngIf="userActionsCardExpanded">
                                <svg width="10" height="6" viewBox="0 0 10 6" fill="none"
                                    xmlns="http://www.w3.org/2000/svg">
                                    <path d="M9 5L5 1L1 5" stroke="#17171A" stroke-width="1.5" stroke-linecap="round"
                                        stroke-linejoin="round" />
                                </svg>
                            </button>
                        </div>
                    </div>
                    <div *ngIf="userActionsCardExpanded" class="asset-card-content" @slideToggle>
                        <div class="asset-card-info row">
                            <div class="col-6 asset-card-content-title"> First Captured User </div>
                            <div class="col-6 asset-card-content-value">
                                {{ selectedSubstation.firstCapturedUser | hasValue }}
                            </div>
                        </div>
                        <div class="asset-card-info row">
                            <div class="col-7 asset-card-content-title"> Last Updated User </div>
                            <div class="col-5 asset-card-content-value">
                                {{ selectedSubstation.lastUpdatedUser | hasValue }}
                            </div>
                        </div>
                        <div class="asset-card-info row">
                            <div class="col-5 asset-card-content-title"> Creation Date </div>
                            <div class="col-7 asset-card-content-value">
                                {{ selectedSubstation.creationDate | hasValue }}
                            </div>
                        </div>
                        <div class="asset-card-info row">
                            <div class="col-6 asset-card-content-title"> Last Update Time </div>
                            <div class="col-6 asset-card-content-value">
                                {{ selectedSubstation.lastUpdateTime | hasValue }}
                            </div>
                        </div>
                        <div class="asset-card-info row">
                            <div class="col-7 asset-card-content-title">
                                {{ "COMMON.USER.TYPE.REASSIGNED" | translate }}
                            </div>
                            <div class="col-5 asset-card-content-value">
                                {{ selectedSubstation.reassignedBy | hasValue }}
                            </div>
                        </div>
                        <div class="asset-card-info row">
                            <div class="col-5 asset-card-content-title">
                                {{ "COMMON.MBC_DETAILS.ASSIGNED" | translate }}
                            </div>
                            <div class="col-7 asset-card-content-value">
                                {{ selectedSubstation.assignedBy | hasValue }}
                            </div>
                        </div>
                        <div class="asset-card-info row">
                            <div class="col-7 asset-card-content-title">
                                {{ "COMMON.VALIDATION_STATUS" | translate }}
                            </div>
                            <div class="col-5 asset-card-content-value">
                                {{ selectedSubstation.validationStatus | hasValue }}
                            </div>
                        </div>
                        <div class="asset-card-info row">
                            <div class="col-7 asset-card-content-title">
                                {{ "COMMON.USER.TYPE.VALIDATED" | translate }}
                            </div>
                            <div class="col-5 asset-card-content-value">
                                {{ selectedSubstation.validatedBy | hasValue }}
                            </div>
                        </div>
                        <div class="asset-card-info row">
                            <div class="col-7 asset-card-content-title">
                                {{ "COMMON.DATE_TYPE.VALIDATED" | translate }}
                            </div>
                            <div class="col-5 asset-card-content-value">
                                {{ selectedSubstation.validationDate | date:'dd/MM/yyyy':'{{ timeZone


                                }}' | hasValue }}
                            </div>
                        </div>
                        <div class="asset-card-info row">
                            <div class="col-7 asset-card-content-title">
                                {{ "COMMON.MBC_DETAILS.AUDITED_STATUS" | translate }}
                            </div>
                            <div class="col-5 asset-card-content-value">
                                {{ selectedSubstation.auditedStatus | hasValue }}
                            </div>
                        </div>
                        <div class="asset-card-info row">
                            <div class="col-7 asset-card-content-title">
                                {{ "COMMON.USER.TYPE.AUDITED" | translate }}
                            </div>
                            <div class="col-5 asset-card-content-value">
                                {{ selectedSubstation.auditedBy | hasValue }}
                            </div>
                        </div>
                        <div class="asset-card-info row">
                            <div class="col-7 asset-card-content-title">
                                {{ "COMMON.MBC_DETAILS.AUDITED_DATE" | translate }}
                            </div>
                            <div class="col-5 asset-card-content-value">
                                {{ selectedSubstation.auditedDateTime | date:'dd/MM/yyyy':'{{ timeZone


                                }}' | hasValue }}
                            </div>
                        </div>
                        <div class="asset-card-info row">
                            <div class="col-7 asset-card-content-title">
                                {{ "COMMON.REVIEW_STATUS" | translate }}
                            </div>
                            <div class="col-5 asset-card-content-value">
                                {{ selectedSubstation.reviewStatus | hasValue }}
                            </div>
                        </div>                        
                        <div class="asset-card-info row">
                            <div class="col-7 asset-card-content-title">
                                {{ "INSTALLATIONS.DETAILS.REVIEWED_BY" | translate }}
                            </div>
                            <div class="col-5 asset-card-content-value">
                                {{ selectedSubstation.reviewedBy | hasValue }}
                            </div>
                        </div>
                        <div class="asset-card-info row">
                            <div class="col-7 asset-card-content-title">
                                {{ "INSTALLATIONS.DETAILS.REVIEWED_DATE" | translate }}
                            </div>
                            <div class="col-5 asset-card-content-value">
                                {{ selectedSubstation.reviewedDate | date:'dd/MM/yyyy':'{{ timeZone }}' | hasValue }}
                            </div>
                        </div>
                        <div class="asset-card-info row">
                            <div class="col-7 asset-card-content-title">
                                {{ "COMMON.GIS_REVIEW_STATUS" | translate }}
                            </div>
                            <div class="col-5 asset-card-content-value">
                                {{ selectedSubstation.gisReviewStatus | hasValue }}
                            </div>
                        </div>
                        <div class="asset-card-info row">
                            <div class="col-7 asset-card-content-title">
                                {{ "COMMON.GIS_REVIEWED_BY" | translate }}
                            </div>
                            <div class="col-5 asset-card-content-value">
                                {{ selectedSubstation.gisReviewedBy | hasValue }}
                            </div>
                        </div>
                        <div class="asset-card-info row">
                            <div class="col-7 asset-card-content-title">
                                {{ "COMMON.GIS_REVIEW_DATE" | translate }}
                            </div>
                            <div class="col-5 asset-card-content-value">
                                {{ selectedSubstation.gisReviewDate | date:'dd/MM/yyyy':'{{ timeZone }}' | hasValue }}
                            </div>
                        </div>
                        <div class="asset-card-info row">
                            <div class="col-7 asset-card-content-title">
                                {{ "COMMON.GIS_UPDATE_STATUS" | translate }}
                            </div>
                            <div class="col-5 asset-card-content-value">
                                {{ selectedSubstation.gisReviewUpdateStatus | hasValue }}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-xl-4 col-md-6 d-flex flex-column gap-3">
                <lib-section-instance-column [sections]="sectionInstances" [equipmentInstances]="equipmentInstances"
                    columnAlign="center" [isSubstation]="true" [editEnabled]="editEnabled"
                    [editableAttributeIds]="editableAttributeIds" [editedValues]="editedValues"
                    [equipmentEditableAttributeIds]="powerTransformerEditableAttributeIds" [editedEquipmentValues]="editedEquipmentValues"
                    [isAssetRatingEditable]="isAssetRatingEditable" [assetRatingOptions]="assetRatingOptions"
                    [editedAssetRatings]="editedAssetRatings"
                    (mapClicked)="setClickedLocation($event)">
                </lib-section-instance-column>
            </div>
            <div class="col-xl-4 col-md-6 d-flex flex-column gap-3">
                <lib-section-instance-column [sections]="sectionInstances" columnAlign="right" [editEnabled]="editEnabled"
                    [editableAttributeIds]="editableAttributeIds" [editedValues]="editedValues"
                    (mapClicked)="setClickedLocation($event)">
                </lib-section-instance-column>
            </div>
        </div>
    </div>
</div>


<div class="modal modalMap" id="showMap" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
            <div class="modal-header">
                <button type="button" #closeAddModal class="close" data-bs-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
                <lib-asset-map [setMapVisibility]="isMapVisible" [longitude]="selectedSubstation.longitude"
                    [latitude]="selectedSubstation.latitude">
                </lib-asset-map>
            </div>
        </div>
    </div>
</div>

<div class="modal fade" id="assignToFieldAgent" tabindex="-1" aria-hidden="true" (hidden.bs.modal)="onModalAssignFade()"
    (shown.bs.modal)="onAssignModalShown()">
    <lib-assign-task-modal [areaId]="0" [assignTask]="assignTask" (idSelected)="selectFieldAgent($event)">
    </lib-assign-task-modal>
</div>


<div class="modal fade" id="auditReview" tabindex="-1" aria-hidden="true">
    <lib-audit-review assetType="SubstationTemplate" [assetId]="selectedSubstation.id"
        [areaId]="selectedSubstation.subGeographicalRegionId!"></lib-audit-review>
</div>

<div class="modal fade" id="updateStatus" tabindex="-1" aria-hidden="true" *ngIf="cimDataQuality">
    <lib-data-quality [assetType]="'SubstationTemplate'" [assetId]="selectedSubstation.id"
        [cimDataQuality]="cimDataQuality" (closeModal)="reload($event)"></lib-data-quality>
</div>


<div class="modal fade" id="review" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">{{'COMMON.REVIEW' | translate}}</h5>
          <button type="button" #closeReviewModal class="btn-cancel-modal" data-bs-dismiss="modal" aria-label="Close">
            {{'COMMON.CANCEL' | translate}}
          </button>
        </div>
        <lib-review (closeModal)="cancelReviewModal($event)" assetType="Cim Substation" [assetId]="selectedSubstation.id"></lib-review>
      </div>
    </div>
  </div>
<div class="modal fade" id="gisReview" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">{{"ROLE_MANAGEMENT.GIS_REVIEW" | translate}}</h5>
          <button type="button" #closeGisReviewModal class="btn-cancel-modal" data-bs-dismiss="modal" aria-label="Close">
            {{"COMMON.CANCEL" | translate}}
          </button>
        </div>
        <div class="modal-footer updateStatus">
            <div>
                <h3>{{"REVIEW.GIS_QUESTION" | translate}}</h3>
            </div>
            <button type="button" class="btn btn-primary approve" (click)="submitGisReview(true)">
                {{"COMMON.YES" | translate}}
            </button>
            <button type="button" class="btn btn-danger" (click)="submitGisReview(false)">
                {{"COMMON.NO" | translate}}
            </button>
        </div>
      </div>
    </div>
  </div>
